/**
 * Created by Samj on 2017/7/21.
 */
import React  from 'react';
import ReactDOM from 'react-dom';
import ConfirmDialog from './ConfirmDialog';
import MessageDialog from './MessageDialog';
import TitleDialog from './TitleDialog';

//创建对话框容器
const CreateContainer = (Component,type) => {
    return props => {
        const wrapper = document.body.appendChild(document.createElement('div'));

        //创建容器回调
        const promise = new Promise((resolve, reject) => {
            try{
                ReactDOM.render(
                    <Component
                        resolve = {resolve}
                        reject = {reject}
                        dispose = {dispose}
                        {...props}
                    />,wrapper);
                if (type=='message') {
                    setTimeout(()=>{dispose();});
                }
            }catch (e){
                throw e;
            }
        })

        function dispose() {
            setTimeout(()=>{
                ReactDOM.unmountComponentAtNode(wrapper);
                setTimeout(()=>wrapper.remove());
            },2000)
        }

        return promise.then(result=>{
            dispose();
            return result;
        },result=>{
            dispose();
            return Promise.reject(result);
        })
    }
}




const confirmContainer = CreateContainer(ConfirmDialog);

export function ysConfirm(content, options = {}) {
    return confirmContainer({ content, ...options });
}
    
const messageContainer = CreateContainer(MessageDialog,'message');

export function ysMessage(content, options = {}) {
    return messageContainer({ content, ...options });
}


const titleContainer = CreateContainer(TitleDialog);

export function ysTitle(title,content, options = {}) {
    return titleContainer({ title,content, ...options });
}




// WEBPACK FOOTER //
// ./src/components/yunshl/Dialog/DialogAction.js